import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { appActions } from "./actions";
import { AppState } from "./types";

const initialState: AppState = {
  isLoading: false,
  showModal: false,
  modalObject: {
    title: "",
    buttons: [],
  },
  showNotification: false,
  notificationObject: {
    type: "success",
    message: "",
  },
  showSidebarSP: false,
};

export function AppReducer(state = initialState, action: Action): AppState {
  if (isType(action, appActions.showLoading)) {
    return {
      ...state,
      isLoading: true,
    };
  }

  if (isType(action, appActions.hideLoading)) {
    return {
      ...state,
      isLoading: false,
    };
  }

  if (isType(action, appActions.showModal)) {
    return {
      ...state,
      showModal: true,
      modalObject: action.payload,
    };
  }

  if (isType(action, appActions.hideModal)) {
    return {
      ...state,
      showModal: false,
      modalObject: {
        title: "",
        buttons: [],
      },
    };
  }

  if (isType(action, appActions.showNotification)) {
    return {
      ...state,
      showNotification: true,
      notificationObject: action.payload,
    };
  }

  if (isType(action, appActions.hideNotification)) {
    return {
      ...state,
      showNotification: false,
      notificationObject: {
        type: "success",
        message: "",
      },
    };
  }

  if (isType(action, appActions.showSidebarSP)) {
    return {
      ...state,
      showSidebarSP: true,
    };
  }

  if (isType(action, appActions.hideSidebarSP)) {
    return {
      ...state,
      showSidebarSP: false,
    };
  }

  if (isType(action, appActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
